import { lazy, Suspense, useState } from 'react';
import { IconButton } from '@astryxdesign/core/IconButton';
import { ChatCircleDotsIcon } from '@phosphor-icons/react';
import type { PublicTenant } from '@/features/tenant/schemas';

const ChatSheet = lazy(() => import('./ChatSheet'));

/** Floating entry point to the site assistant; the chat itself loads on first open. */
export function ChatButton({ tenant }: { tenant: PublicTenant }) {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  return (
    <>
      <IconButton
        label="Задать вопрос помощнику"
        variant="primary"
        size="lg"
        elevation="med"
        className="app-chat-fab"
        icon={<ChatCircleDotsIcon size={26} weight="fill" />}
        onClick={() => { setLoaded(true); setOpen(true); }}
      />
      {loaded ? (
        <Suspense fallback={null}>
          <ChatSheet tenant={tenant} open={open} onOpenChange={setOpen} />
        </Suspense>
      ) : null}
    </>
  );
}
